/* ════════════════════════════════════════════════════════════
   VELVET RITUALS — Learn (blog ecosystem) behaviour
   assets/vr-learn.js

   1. Scroll reveal for .vrl-r (same spring pattern sitewide)
   2. Article TOC: reads h2/h3 from the prose, builds the desktop
      progress spine and the mobile contents sheet, scroll-spies
      the active section, fills the spine + chip ring with
      reading progress.
   3. Inline image slots: <template data-vrl-slot> blocks are
      moved into the prose — either replacing an import-script
      marker (<div data-vrl-slot="N">) or after the Nth h2.
   Self-guards so multiple section includes run it once.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__vrLearnInit) return;
  window.__vrLearnInit = true;

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  ready(function () {
    /* ── Scroll reveal ─────────────────────────────────── */
    var revealEls = document.querySelectorAll('.vrl-r');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('in'); });
    }

    /* ── Related-products strip: live cart-quantity counter (mirrors
       sections/related-products.liquid) ─────────────────────────── */
    var qtyBadges = document.querySelectorAll('[data-vrpc-qty]');
    if (qtyBadges.length) {
      var applyCart = function (cart) {
        if (!cart) return;
        var q = {};
        (cart.items || []).forEach(function (it) { var k = String(it.variant_id); q[k] = (q[k] || 0) + it.quantity; });
        qtyBadges.forEach(function (b) {
          var n = q[b.getAttribute('data-id')] || 0;
          if (n > 0) { b.textContent = n; b.hidden = false; } else { b.hidden = true; }
        });
      };
      document.addEventListener('vr:cart:updated', function (e) { applyCart(e.detail); });
      if (window.VRCart && window.VRCart.cart) applyCart(window.VRCart.cart);
    }

    var prose = document.querySelector('[data-vrl-prose]');
    if (!prose) return;

    /* ── Inline image slots ────────────────────────────── */
    document.querySelectorAll('template[data-vrl-slot]').forEach(function (tpl) {
      var pos = tpl.getAttribute('data-vrl-slot') || '';
      var frag = tpl.content.cloneNode(true);
      var marker;
      var m = pos.match(/^marker:(\d+)$/);
      if (m) {
        marker = prose.querySelector('[data-vrl-slot="' + m[1] + '"]');
        if (marker) { marker.replaceWith(frag); return; }
        // No matching marker in this article's content — drop the slot.
        return;
      }
      m = pos.match(/^h2:(\d+)$/);
      if (m) {
        var headings = prose.querySelectorAll('h2');
        var n = parseInt(m[1], 10);
        if (headings.length >= n) {
          // "After section N" = just before heading N+1, or at the end.
          var next = headings[n]; // 0-indexed: headings[n] is the (N+1)th
          if (next) next.before(frag);
          else prose.appendChild(frag);
          return;
        }
        return;
      }
      if (pos === 'lead') {
        var firstP = prose.querySelector('p');
        if (firstP) firstP.after(frag);
        else prose.prepend(frag);
        return;
      }
      prose.appendChild(frag); // pos === 'end' or anything unrecognised
    });

    /* ── TOC build ─────────────────────────────────────── */
    var spineList = document.querySelector('[data-vrl-spine-list]');
    var sheetList = document.querySelector('[data-vrl-sheet-list]');
    var headings = Array.prototype.slice.call(prose.querySelectorAll('h2, h3'));
    // An article that is one unbroken block of text gets no rail.
    var spine = document.querySelector('[data-vrl-spine]');
    var chip = document.querySelector('[data-vrl-chip]');
    if (!headings.length) {
      if (spine) spine.hidden = true;
      if (chip) chip.remove();
      return;
    }

    var slug = function (text, i) {
      var s = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      return (s || 'section') + '-' + i;
    };

    var links = [];
    headings.forEach(function (h, i) {
      if (!h.id) h.id = slug(h.textContent, i);
      var lvl3 = h.tagName === 'H3' ? ' lvl3' : '';
      [spineList, sheetList].forEach(function (list) {
        if (!list) return;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.className = lvl3.trim();
        li.appendChild(a);
        list.appendChild(li);
        links.push({ el: a, target: h });
      });
    });

    /* ── Scroll spy + progress ─────────────────────────── */
    var fill = document.querySelector('[data-vrl-spine-fill]');
    var ring = document.querySelector('[data-vrl-chip-ring] .fg');
    var ringLen = 0;
    if (ring) {
      ringLen = 2 * Math.PI * parseFloat(ring.getAttribute('r'));
      ring.style.strokeDasharray = ringLen;
      ring.style.strokeDashoffset = ringLen;
    }

    var ticking = false;
    var update = function () {
      ticking = false;
      var rect = prose.getBoundingClientRect();
      var vh = window.innerHeight;
      // Progress: how much of the prose has scrolled past the fold midpoint
      var total = rect.height - vh * 0.5;
      var passed = Math.min(Math.max(vh * 0.5 - rect.top, 0), Math.max(total, 1));
      var progress = total > 0 ? passed / total : 1;
      if (fill) fill.style.transform = 'scaleY(' + progress + ')';
      if (ring) ring.style.strokeDashoffset = ringLen * (1 - progress);
      if (chip) chip.classList.toggle('is-on', rect.top < vh * 0.4 && rect.bottom > vh * 0.6);

      // Active heading: the last one above the 35% line
      var current = null;
      for (var i = 0; i < headings.length; i++) {
        if (headings[i].getBoundingClientRect().top <= vh * 0.35) current = headings[i];
        else break;
      }
      links.forEach(function (l) {
        l.el.classList.toggle('is-active', l.target === current);
      });
    };
    var onScroll = function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();

    /* ── Mobile contents sheet ─────────────────────────── */
    var sheet = document.querySelector('[data-vrl-sheet]');
    var veil = document.querySelector('[data-vrl-veil]');
    if (chip && sheet && veil) {
      var open = function () {
        sheet.classList.add('is-open');
        veil.classList.add('is-open');
        chip.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      };
      var close = function () {
        sheet.classList.remove('is-open');
        veil.classList.remove('is-open');
        chip.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      };
      chip.addEventListener('click', function () {
        sheet.classList.contains('is-open') ? close() : open();
      });
      veil.addEventListener('click', close);
      sheet.addEventListener('click', function (e) {
        if (e.target.closest('a')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sheet.classList.contains('is-open')) close();
      });
    }
  });
})();
